export type AuthMode = 'msal' | 'token'

const rawAuthMode = import.meta.env.VITE_AUTH_MODE || 'msal'

if (rawAuthMode !== 'msal' && rawAuthMode !== 'token') {
  throw new Error(`Unsupported VITE_AUTH_MODE "${rawAuthMode}". Expected "msal" or "token".`)
}

export const authMode: AuthMode = rawAuthMode
export const isTokenAuthMode = authMode === 'token'
export const useMockAuth =
  (import.meta.env.DEV && import.meta.env.VITE_MOCK_AP_INVOICES === '1') ||
  import.meta.env.VITE_E2E_MOCK_AUTH === '1'

export const dashboardApiBaseUrl = import.meta.env.VITE_API_URL || 'http://localhost:80'

export const stagingTokenStorageKey = 'usars:staging-dashboard-token'
export const stagingTokenUserStorageKey = 'usars:staging-dashboard-user'

const isDevelopmentTokenAuth = import.meta.env.VITE_APP_ENV === 'development'

export const stagingTokenCopy = isDevelopmentTokenAuth
  ? {
      eyebrow: 'Local development access',
      description: 'Enter the local USA-RS development token to continue.',
      tokenLabel: 'API token',
      tokenPlaceholder: 'usars_...',
      submit: 'Continue locally',
    }
  : {
      eyebrow: 'Staging token access',
      description: 'Internal staging only. Enter a USA-RS API token to continue.',
      tokenLabel: 'API token',
      tokenPlaceholder: 'usars_...',
      submit: 'Continue to staging',
    }

export const tokenAuthErrors = isDevelopmentTokenAuth
  ? {
      rejected: 'Development API rejected this token.',
      unavailable: 'Could not verify the development token. Check the local API and try again.',
    }
  : {
      rejected: 'Staging API rejected this token.',
      unavailable: 'Could not verify staging token. Check the staging API and try again.',
    }
